import { RefObject, useEffect, useState } from 'react'

const BASELINE = 170
const CUTOFF = 260

/** 시안 markActive() 와 같은 규칙 — 기준선 170px 에 가장 가깝고, 260px 위에 있는 섹션. */
export const pickActiveSection = (tops: { id: string; top: number }[]): string | null => {
  let best: string | null = null
  let bestDistance = Number.POSITIVE_INFINITY

  tops.forEach(({ id, top }) => {
    if (top >= CUTOFF) return
    const d = Math.abs(top - BASELINE)
    if (d < bestDistance) {
      bestDistance = d
      best = id
    }
  })

  return best
}

/**
 * LOGISPRD-13139 — 스크롤은 창이 아니라 `root`(.moms-console-body)에서 일어난다. 기준선은 시안대로
 * 스크롤 박스 맨 위에서 잰 값이라, 섹션 위치에서 박스의 뷰포트 위치(헤더 높이)를 뺀다.
 */
export const useScrollSpy = (sectionIds: string[], root: RefObject<HTMLElement>): string | null => {
  const [active, setActive] = useState<string | null>(null)

  useEffect(() => {
    const scroller = root.current
    if (!scroller) return

    const onScroll = (): void => {
      const rootTop = scroller.getBoundingClientRect().top
      const tops = sectionIds
        .map((id) => ({ id, el: document.getElementById(id) }))
        .filter((x): x is { id: string; el: HTMLElement } => x.el !== null)
        .map(({ id, el }) => ({ id, top: el.getBoundingClientRect().top - rootTop }))
      setActive(pickActiveSection(tops))
    }

    onScroll()
    scroller.addEventListener('scroll', onScroll, { passive: true })
    return () => scroller.removeEventListener('scroll', onScroll)
  }, [sectionIds])

  return active
}
